import { HamburgerMenuIcon } from "@header/HamburgerMenu/HamburgerMenuIcon";
import { SearchButton } from "@header/Search/SearchButton";
import UserInfo from "@header/TopHeader/UserInfo/UserInfo";
import { QUICKNEWS_FLAG } from "@helper/getEnvVariables";
import { QnHeaderIcon } from "@modules/QuickNews/QnButtons";
import { twMerge } from "tailwind-merge";

type HeaderWrapperProps = {
  onClick: () => void;
  searchExpanded: boolean;
  toggleMobileMenu: () => void;
  expandMenu: boolean;
  showMenuIcon: boolean;
  showUserIcon?: boolean;
};

export function HeaderLeftWrapper({
  onClick,
  searchExpanded,
  toggleMobileMenu,
  expandMenu,
  showMenuIcon,
  showUserIcon = false,
}: HeaderWrapperProps) {
  return (
    <div
      className={twMerge("float-right inline-flex gap-2 md:gap-5 items-center")}
    >
      <a
        href="https://e-paper.sph.com.sg/tabla"
        rel="epaper noreferrer"
        title="E-Paper"
        target="_blank"
        className="items-center xmd:justify-center flex text-yellow-100 text-sm font-opensans font-bold leading-5.5"
      >
        E-Paper
      </a>
      <span className="text-grey-400 h-[26px] border-solid border-[1px] border-grey-400 opacity-50"></span>
      {QUICKNEWS_FLAG === "1" && (
        <>
          <QnHeaderIcon />
          <span className="text-grey-400 h-[26px] border-solid border-[1px] border-grey-400 opacity-50"></span>
        </>
      )}
      <SearchButton onClick={onClick} expanded={searchExpanded} />

      <span className="inline-flex lg:hidden text-grey-400 h-[26px] border-solid border-[1px] border-grey-400 opacity-50"></span>
      <div className="inline-flex lg:hidden">
        <HamburgerMenuIcon
          showMenuIcon={showMenuIcon}
          expandMenu={expandMenu}
          onClick={toggleMobileMenu}
        />
      </div>

      {showUserIcon && (
        <>
          <span className="hidden lg:inline-flex text-grey-400 h-[26px] border-solid border-[1px] border-grey-400 opacity-50"></span>
          <div className="hidden lg:inline-flex">
            <UserInfo topHeader={false} isScrolledHeader={true} />
          </div>
        </>
      )}
    </div>
  );
}
